module.exports = __webpack_public_path__ + "static/about_pic2-2f825b02998176bd0432d446179c2466.png";